import type { Notification } from '@/entities/notification';
import { usePermissionsService } from '@/composables/usePermissionsService';

export function useNotificationSelectionRules() {
  const permissionsService = usePermissionsService();

  const REPORT_AVAILABLE_NOTIFICATION_ID = 'report_available';

  function isReportAvailable(notification: Notification): boolean {
    return String(notification.notificationId) === REPORT_AVAILABLE_NOTIFICATION_ID;
  }

  function isForcedForExternalUser(notification: Notification): boolean {
    return permissionsService.hasRoleExternalUser && isReportAvailable(notification);
  }

  function isNotificationChecked(
    notification: Notification,
    selectedNotificationState: boolean | null,
    selectedNotifications: Array<string | number>,
    includeMandatoryWhenActive = false
  ): boolean {
    if (isForcedForExternalUser(notification)) {
      return true;
    }

    const isSelected = selectedNotifications
      .map(String)
      .includes(String(notification.notificationId));

    return Boolean(
      isSelected ||
      (includeMandatoryWhenActive &&
        notification.isMandatory &&
        selectedNotificationState)
    );
  }

  function isNotificationReadOnly(
    notification: Notification,
    selectedNotificationState: boolean | null,
    additionalDisabled = false
  ): boolean {
    return (
      isForcedForExternalUser(notification) ||
      !selectedNotificationState ||
      additionalDisabled
    );
  }

  return {
    isForcedForExternalUser,
    isNotificationChecked,
    isNotificationReadOnly,
  };
}
